import React from 'react';
import {Link} from 'react-router-dom';

export default function Error() {
    return (
        <div>
            <h1>
                404
            </h1>
            <p>
                Page is not available, deleted or does not exist. <Link to="/">Click here to get back to homepage</Link>
            </p>
            
        </div>
    )
}